const YEAR_ADDYEARFORM = ({ endDate, handleOnChange, createYear }) => {
	const currentYear = new Date().getFullYear();
	const nextYearDate = new Date();
	nextYearDate.setFullYear(nextYearDate.getFullYear() + 1);
	const day = nextYearDate.getDate();
	const suffix = [11, 12, 13].includes(day) ? 'th' : { 1: 'st', 2: 'nd', 3: 'rd' }[day % 10] || 'th';
	const recommendedDate = `${day}${suffix} ${nextYearDate.toLocaleDateString('en-GB', { month: 'long', year: 'numeric' })}`;
	return (
		<>

			<h1 className="text-align--center">You haven't started a year yet.</h1>
			<p>Click below to set an end date. After that, you can add goals, set up your quarters, and begin Hammering your Backlog for {currentYear}.</p>
			<form id="createYearForm">
				<div>
					<input
						type="date"
						name="endDate"
						value={endDate}
						onChange={handleOnChange}
					/>
					<span>We recommend {recommendedDate} as it's 365 days from now. However, you can pick any date you'd like — simply click the button above and set your own date.</span>
				</div>
				<button onClick={createYear}>Start my year</button>
			</form>
		</>
	);
};

export default YEAR_ADDYEARFORM